import React, { FC, memo } from 'react';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
// Import UI Components
import { Button, Tooltip } from '@geneui/components';
// Import  Constants
import { l, ActionsIcons, EmailProviderTypeLabels } from 'constants/common';

interface Props {
    data: Record<string, unknown>;
    editProviderAction: (data: Record<string, unknown>) => void;
    cloneProviderAction: (data: Record<string, unknown>) => void;
}

const AdminEmailProviderActionsButtons: FC<Props> = ({ data, editProviderAction, cloneProviderAction }) => {
    const { t } = useTranslation();

    const isVisibleEditProvider = () => !isEmpty(data) && data.Type === EmailProviderTypeLabels.SMTP;
    const isVisibleCloneProvider = () => !isEmpty(data) && data.Type === EmailProviderTypeLabels.SMTP;

    return (
        <>
            {isVisibleEditProvider() && (
                <Tooltip text={t(l.EditProvider)}>
                    <Button
                        flexibility="default"
                        icon={ActionsIcons.Edit}
                        appearance="minimal"
                        color="primary"
                        onClick={() => editProviderAction(data)}
                        children={undefined}
                    />
                </Tooltip>
            )}
            {isVisibleCloneProvider() && (
                <Tooltip text={t(l.CloneProvider)}>
                    <Button
                        flexibility="default"
                        icon={ActionsIcons.Clone}
                        appearance="minimal"
                        color="primary"
                        onClick={() => cloneProviderAction(data)}
                        children={undefined}
                    />
                </Tooltip>
            )}
        </>
    );
};

export default memo(AdminEmailProviderActionsButtons);
